import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { mapToServiceRequest } from '~/modules/resourcing/common/util';
import { ResourceRequestStatus } from '~/types';
import { getCompleteResourceRequestQueries } from './withMarkResourceRequestAsComplete';

const useMarkResourceRequestAsComplete = ({
  resourceRequest,
  showTimeOff,
  chartDateRange,
  showHolidays,
  additionalRequestParams,
  cacheUpdateFunctions
}) => {
  const { mutationDocument } = getCompleteResourceRequestQueries();

  const [
    markResourceRequestAsComplete,
    { error: markAsCompleteError }
  ] = useMutation(mutationDocument);

  const onMarkResourceRequestAsComplete = useCallback(() => {
    const requestParams = {
      request: resourceRequest,
      responseType: 'markResourceRequestAsComplete2',
      responseTypeName: 'MarkResourceRequestAsCompleteResult',
      requestStatus: ResourceRequestStatus.Complete,
      ...additionalRequestParams
    };

    markResourceRequestAsComplete(
      mapToServiceRequest({
        ...requestParams,
        chartDateRange,
        showTimeOff: Boolean(showTimeOff),
        showHolidays: Boolean(showHolidays),
        cacheUpdateFunctions
      })
    );
  }, [
    resourceRequest,
    additionalRequestParams,
    markResourceRequestAsComplete,
    chartDateRange,
    showTimeOff,
    showHolidays,
    cacheUpdateFunctions
  ]);

  return {
    onMarkResourceRequestAsComplete,
    error: markAsCompleteError
  };
};

export default useMarkResourceRequestAsComplete;
